var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4455 4652 c-225 -224 -1306 -1301 -2401 -2394 l-1991 -1986 106 -105 106 -105 2400 2393 2400 2393 -99 103 c-55 57 -102 105 -105 106 -3 2 -190 -181 -416 -405z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2350 4203 c-19 -2 -84 -13 -145 -24 -556 -102 -1115 -430 -1661 -974 -185 -185 -321 -339 -449 -510 -45 -60 -85 -115 -89 -122 -9 -17 176 -259 331 -433 148 -165 340 -353 492 -481 l105 -87 323 316 c225 220 322 321 318 332 -4 8 -16 49 -28 90 -19 65 -22 98 -21 260 0 172 2 191 27 275 111 364 369 622 732 732 84 25 102 27 280 27 178 0 195 -1 275 -26 l85 -27 243 242 243 243 -103 38 c-133 50 -336 101 -477 120 -102 15 -381 20 -481 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3880 3231 l-324 -317 17 -59 c57 -204 51 -435 -15 -630 -133 -389 -493 -671 -900 -704 -117 -9 -250 1 -358 29 l-84 21 -238 -238 c-130 -130 -234 -241 -229 -246 15 -15 223 -84 331 -110 313 -77 643 -78 953 -6 388 91 817 319 1215 647 280 230 706 690 856 923 16 26 16 26 -72 146 -183 247 -534 620 -753 799 l-75 62 -324 -317z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380 3290 c-41 -11 -113 -39 -160 -62 -69 -34 -103 -60 -180 -138 -78 -77 -104 -111 -138 -180 -58 -117 -82 -218 -82 -347 0 -56 3 -103 7 -103 10 0 843 833 843 842 0 17 -214 7 -290 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2885 2240 l-420 -420 45 -1 c161 -6 278 18 398 81 191 99 340 289 387 494 14 58 23 252 13 262 -2 2 -193 -186 -423 -416z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default __webpack_public_path__ + "static/media/hidden.969b578b.svg";
export { ForwardRef as ReactComponent };